import getFreshSideObject from "./getFreshSideObject.js";
export default function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/moulet-avocat-mont-de-marsan.fr/httpdocs/wp-content/themes/moulet/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
// module id = 35
// module chunks = 0